<main class="" id="templateContainer">
  <form (ngSubmit)="onSubmit()" *ngIf="formAgenda && this.agenda" [formGroup]="formAgenda" id="idFormAgenda" name="formAgenda">
    <div class="form-container p-fluid">
      <div class="align-card">
        <div class="" style="display: flex; margin-left: -1.6rem;">
          <span>
            <i (click)="goBack()" class="pi pi-arrow-left"
              style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
          </span>
          <div>
            <app-fiel-title label="Lote N° {{ agenda?.numeroLote }}"></app-fiel-title>
          </div>
        </div>
        <div class=" p-mt-2">
          <app-fiel-title label="Empresa: "></app-fiel-title>
          <label>{{ agenda?.empresa }}</label>
        </div>
        <div class=" p-mt-2">
          <app-fiel-title label="Establecimiento: "></app-fiel-title>
          <label>{{ agenda?.establecimiento }}</label>
        </div>
      </div>
      <div class="p-grid p-mt-5" style="justify-content: space-between;">
        <div class="p-col-12 p-md-6">
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Datos del contacto"></app-fiel-title>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.contactoEmpresaNombre.invalid}" alfanumericoDirective
              formControlName="contactoEmpresaNombre" id="contactoEmpresaNombre" name="contactoEmpresaNombre" maxlength="150"
              pInputText type="text"/>
            <app-invalid-from-message *ngIf="submitted && f.contactoEmpresaNombre.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Email" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.contactoEmpresaMail.invalid}"
              formControlName="contactoEmpresaMail" id="contactoEmpresaMail" name="contactoEmpresaMail" maxlength="150"
              pInputText type="text"type="email" [email]="true"/>
            <app-invalid-from-message *ngIf="submitted && f.contactoEmpresaMail.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.contactoEmpresaMail.errors?.email" message="Ingrese un Email válido"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Teléfono" required="true"></app-fiel-title>
            <p-inputNumber [ngClass]="{'ng-invalid ng-dirty': submitted && f.contactoEmpresaTelefono.invalid}"
              formControlName="contactoEmpresaTelefono" id="contactoEmpresaTelefono"
              name="contactoEmpresaTelefono" maxlength="25" [useGrouping]="false">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.contactoEmpresaTelefono.errors?.required"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Cargo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.contactoEmpresaCargo.invalid}" alfanumericoDirective
              formControlName="contactoEmpresaCargo" id="contactoEmpresaCargo" name="contactoEmpresaCargo" maxlength="150" pInputText type="text"/>
            <app-invalid-from-message *ngIf="submitted && f.contactoEmpresaCargo.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Datos del médico"></app-fiel-title>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Nombre" ></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedicoNombre.invalid}" alfanumericoDirective
              formControlName="responsableMedicoNombre" id="responsableMedicoNombre" name="responsableMedicoNombre" maxlength="150" pInputText type="text"/>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedicoNombre.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Email" ></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedicoMail.invalid}"
              formControlName="responsableMedicoMail" id="responsableMedicoMail" name="responsableMedicoMail" maxlength="150"
              pInputText type="text" type="email" [email]="true"/>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedicoMail.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedicoMail.errors?.email" message="Ingrese un Email válido"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Teléfono" ></app-fiel-title>
            <p-inputNumber [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedicoTelefono.invalid}"
              formControlName="responsableMedicoTelefono" id="responsableMedicoTelefono"
              name="responsableMedicoTelefono" maxlength="25" [useGrouping]="false">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedicoTelefono.errors?.required"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-fiel-title label="Matrícula" ></app-fiel-title>
            <p-inputNumber [ngClass]="{'ng-invalid ng-dirty': submitted && f.responsableMedicoMatricula.invalid}"
              formControlName="responsableMedicoMatricula" id="responsableMedicoMatricula"
              name="responsableMedicoMatricula" maxlength="25" [useGrouping]="false">
            </p-inputNumber>
            <app-invalid-from-message *ngIf="submitted && f.responsableMedicoMatricula.errors?.required"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div class="p-grid-space print_hide-on-print">
        <label class="p-title-seccion">
          Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.agenda?.idLote" [isExamen]="false"
          [isRequire]="isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
          [attachedFilesFromBackend]="this.agenda?.attachments" [viewMode]="false"
          [esAunPorEnviar]="false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted && isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>

      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose" [disabled]="!isOnline"></p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
        </div>
      </div>
    </div>
  </form>

  <p-confirmDialog #cd [closable]="false" [style]="{ width: '500px' }" key="goBackFormEC" styleClass="p-dialog-custom">
    <p-footer>
      <button (click)="cd.reject()" class="p-button-text" label="No, volver a la agenda" pButton type="button"></button>
      <button (click)="cd.accept()" label="Si, cancelar carga" pButton type="button"></button>
    </p-footer>

  </p-confirmDialog>
</main>



